import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const formControlLabelTheme: Pick<
  Components<Theme>,
  'MuiFormControlLabel'
> = {
  MuiFormControlLabel: {
    styleOverrides: {
      label: ({ theme }) => {
        return {
          // checkbox / radio group / switch -- set smaller font size -- mui defaults to 16px
          fontSize: theme.typography.body2.fontSize,
        };
      },
    },
  },
};
